





















import { Loading } from 'vant';
import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import { RequestState } from "@/network/http";

Vue.use(Loading);

@Component({})
export default class PageLoad extends Vue {
  @Prop(String)
  loadingMsg?: string;
  @Prop(String)
  errorMsg?: string;
  @Prop(Number)
  status?: RequestState;

  failIcon: any = require("../assets/images/ic_fail.png");
  pageState: string = "loading";

  created() {
    
  }

  mounted() {
    
  }

  @Watch('status', {immediate: true, deep: true})
  private currState(newState: RequestState, oldState: RequestState) {
    let pageState = "loading";
    if (newState && newState === RequestState.SUCCESS) {
      pageState = "success";
    } else if (newState && newState === RequestState.FAIL) {
      pageState = "fail";
    }

    this.pageState = pageState;
  }


  @Emit("refresh") 
  private onRefresh(): boolean{
    return true;
  }
}
